<!-- THIS WILL BE USED IN HTML2 -->
<!-- IMPORTANT! - For concistency please use the following structure for future development -->
<!-- <div class="user-settings-tab-panel-wrapper">
    <div class="user-settings-control-row" fxLayout="row">
        <div class="row-content" fxflex="80%" fxlayout="column">
            <span [ngClass]="{'disabled': className}" class="user-settings-control-row_title">Setting Title</span>
            <p class="user-settings-control-row_description">Setting Description</p>
        </div>
        <div class="setting_toggle" fxflex="20%" fxlayout="row" fxlayoutalign="center">
            <bfx-toggle></bfx-toggle>
        </div>
    </div>
</div> -->

<div class="userSettings-loading-message" *ngIf="!ready" fxFlexFill>Loading...</div>
<div
  *ngIf="ready"
  class="user-settings-tab-panel-wrapper user-settings-component-container"
  [ngStyle]="panelStyle"
>
  <div class="user-settings-control-row" fxLayout="row">
    <div class="row-content" fxflex="80%">
      <span class="user-settings-control-row_title">Enable Market Bar</span>
      <p class="user-settings-control-row_description">
        Sorts orders above and below the market by % Away in the Blotter.
      </p>
    </div>
    <div fxFlex="20%" class="setting_toggle">
      <bfx-toggle [checked]="marketBar" (change)="enableMarketBarToggle($event)"></bfx-toggle>
    </div>
  </div>
  <div class="user-settings-control-row" fxLayout="row" *ngIf="ready">
    <div class="row-content" fxflex="80%">
      <span class="user-settings-control-row_title">Pause Rates Length</span>
      <p class="user-settings-control-row_description">
        Sets the length of time rates will remain paused before automatically resuming.
      </p>
    </div>
    <div fxFlex="20%" class="setting_toggle">
      <number-spinner
        size="sm"
        [min]="1"
        [max]="999"
        mandatory="true"
        modelValueType="NUMBER"
        [maxPrecision]="0"
        [(ngModel)]="pauseRatesModel"
        [step]="pauseRatesStep"
        [externalState]="pauseRatesModelExternalState"
        (ngModelChange)="pauseRatesBtnClick($event)"
        (blur)="pauseRatesModelonBlur($event)"
      >
      </number-spinner>
    </div>
  </div>
  <div class="user-settings-control-row" fxLayout="row">
    <div class="row-content" fxflex="80%">
      <span class="user-settings-control-row_title">Enable Temperature Row Colours</span>
      <p class="user-settings-control-row_description">
        If disabled, the Hot and Warm colours will only be shown in the Priority column(s).
      </p>
    </div>
    <div fxFlex="20%" class="setting_toggle">
      <bfx-toggle [checked]="tempColorFull" (change)="enableTempColorFull($event)"> </bfx-toggle>
    </div>
  </div>
  <div class="user-settings-control-row" fxLayout="row">
    <div class="row-content" fxflex="80%">
      <span
        [ngClass]="{'disabled': pinTriggeredOrders === false}"
        class="user-settings-control-row_title"
        >Pin Triggered Orders to the Market Bar</span
      >
      <p class="user-settings-control-row_description">
        Triggered orders will pin to the market bar on the appropriate side.
      </p>
    </div>
    <div fxFlex="20%" class="setting_toggle">
      <bfx-toggle [checked]="pinTriggeredOrders" (change)="enablePinTriggeredOrders($event)">
      </bfx-toggle>
    </div>
  </div>
  <div class="user-settings-control-row" fxLayout="row">
    <div class="row-content" fxflex="80%">
      <span
        [ngClass]="{'disabled': supportsAggregation === false}"
        class="user-settings-control-row_title"
        >Enable Ladder Price Level Aggregation</span
      >
      <p class="user-settings-control-row_description">
        If enabled TP, SL, Call orders; by order type at the same spot tracking rates and trader
        group will be aggregated into one row. Outright tracked orders will not be aggregated.
      </p>
    </div>
    <div fxFlex="20%" class="setting_toggle">
      <bfx-toggle [checked]="supportsAggregation" (change)="enableSupportsAggregation($event)">
      </bfx-toggle>
    </div>
  </div>
  <div class="user-settings-control-row" fxLayout="row">
    <div class="row-content" fxflex="80%">
      <span
        [ngClass]="{'disabled': intentStylingEnabled === false}"
        class="user-settings-control-row_title"
        >Enable Buy/Sell Highlight</span
      >
      <p class="user-settings-control-row_description">
        If enabled, BUY and SELL blotter values will be emphasised using color highlights
      </p>
    </div>
    <div fxFlex="20%" class="setting_toggle">
      <bfx-toggle [checked]="intentStylingEnabled" (change)="toggleIntentStyling($event)">
      </bfx-toggle>
    </div>
  </div>
</div>
